import { openBlock as t, createElementBlock as e, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}, r = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3.299 9.575c-.062 1.164.009 2.402-1.03 3.181a1.92 1.92 0 0 0-.769 1.537c0 .832.652 1.54 1.5 1.54h12c.848 0 1.5-.708 1.5-1.54 0-.604-.285-1.174-.768-1.537-1.04-.78-.97-2.017-1.03-3.18a5.71 5.71 0 0 0-11.403 0"
}, null, -1), s = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M7.75 2.604c0 .69.56 1.562 1.25 1.562s1.25-.872 1.25-1.562-.56-.938-1.25-.938-1.25.247-1.25.938Z"
}, null, -1), c = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M11.5 15.832a2.5 2.5 0 0 1-5 0"
}, null, -1), i = [
  r,
  s,
  c
];
function l(d, a) {
  return t(), e("svg", n, [...i]);
}
const u = { render: l };
export {
  u as default,
  l as render
};
